import { render, staticRenderFns } from "./InstagramAccountsBox.vue?vue&type=template&id=125f6d24&"
import script from "./InstagramAccountsBox.vue?vue&type=script&lang=js&"
export * from "./InstagramAccountsBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports